import { makeStyles } from "@material-ui/core/styles";

export function useSearchFieldStyles() {
    const useStyles = makeStyles((theme) => ({
        root: {
            margin: 16,
            width: "40%",
        },
        form: {
            flex: 1,
            maxWidth: "60%",
            display: "flex",
            alignItems: "center",
        },
        searchButton: {
            color: "#004F9F",
            backgroundColor: "#fff",
            border: "1px solid #004F9F",
            boxShadow: "none",
            borderRadius: 5,
            textTransform: "uppercase",
        },
        buttonCancelSearch: {
            borderRadius: 5,
            height: 38,
            minWidth: 110,
            color: "#ff9b38",
            borderColor: "#ff9b38",
            alignItems: "center",
            letterSpacing: 0.3,
            margin: "0px 8px 0px 8px",
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
